module.exports = __webpack_public_path__ + "static/media/newSignature.d57bde3e.svg";